module.exports = __webpack_public_path__ + "5d09feb7ccf27138477fce0a03a4b56f.svg";